export default __webpack_public_path__ + "static/media/Inter-SemiBold.c6588ec1.ttf";